(ns ui.view.survey.modals.num-fmt-select
  (:require [clojure.string :as string]
            [common.localization :as loc]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.modal.view :as modal]
            [ui.view.survey.components :as components]
            [ui.view.survey.event :as survey-event]
            [ui.view.survey.modals.event :as event]
            [ui.view.survey.modals.sub :as sub]
            [ui.view.survey.sub :as survey-view-sub]))

(defn body
  [lang]
  [:div
   {:class "flex flex-col gap-4"}
   [:div
    {:class "flex flex-col gap-2"}
    (->> (loc/tr :info-text-for-selecting-decimal-separator nil lang)
         (string/split-lines)
         (map-indexed (fn [idx para]
                        ^{:key (str ::decimal-info "-" idx)}
                        [:p para]))
         (doall))]
   [:div
    {:class "p-3 flex flex-col flex-auto bg-info-light text-info-light-text rounded"}
    (->> (loc/tr :info-text-for-selecting-decimal-separator-note nil lang)
         (string/split-lines)
         (map-indexed (fn [idx para]
                        ^{:key (str ::decimal-note "-" idx)}
                        [:p para]))
         (doall))]
   [components/thousand-separator]
   [components/decimal-separator]])

(defn footer
  [lang]
  (let [thousand-separator @(rf/subscribe [::survey-view-sub/thousand-separator])
        decimal-separator @(rf/subscribe [::survey-view-sub/decimal-separator])
        valid? (and thousand-separator
                    decimal-separator
                    (not= decimal-separator thousand-separator))]
    [:div
     {:class "flex flex-row flex-auto"}
     [:div
      {:class "flex flex-row justify-content-start"}]
     [:div
      {:class "flex flex-row flex-auto content-stretch justify-content-end"}
      [button/primary-solid
       {:disabled? (not valid?)
        :on-click  (fn [_]
                     (rf/dispatch [::survey-event/set-decimal-separator decimal-separator])
                     (rf/dispatch [::survey-event/set-thousand-separator thousand-separator])
                     (rf/dispatch [::event/close-num-fmt-modal]))}
       (loc/tr :ok nil lang)]]]))

(defn view
  []
  (let [survey-id @(rf/subscribe [::sub/survey-id])
        numeric-questions? @(rf/subscribe [::survey-view-sub/numeric-questions? survey-id])
        modal-open? @(rf/subscribe [::sub/num-fmt-modal-open?])
        lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])]
    [modal/view
     {:visible? (and numeric-questions?
                     modal-open?)
      :hide!    #(rf/dispatch [::event/close-num-fmt-modal])
      :size     :full}
     (loc/tr :survey-num-fmt-modal-title nil lang)
     [body lang]
     [footer lang]]))
